module.exports = __webpack_public_path__ + "img/empty.1dc7dc82.svg";